import { type SelectOption } from '../../../../../../components/SelectDropdown/SelectDropdown'
import { type FormFieldDefinition } from '../../hooks'

export interface ContactLinkNode {
  object: string | null
  field: string | null
  valueType?: string | null
  valueFormat?: string | null
}

export const contactLinkNodeWithSelectedField = (object: string | null, option: SelectOption, fieldDefinition?: FormFieldDefinition): ContactLinkNode => ({
  object,
  field: option.id,
  valueType: fieldDefinition?.type ?? null,
  valueFormat: fieldDefinition?.extraTypeInfo ?? null,
})

export const contactLinkNodeWithSelectedObject = (current: Partial<ContactLinkNode> | null | undefined, objectId: string): ContactLinkNode =>
  current?.object === objectId
    ? { object: objectId, field: current.field ?? null, valueType: current.valueType ?? null, valueFormat: current.valueFormat ?? null }
    : { object: objectId, field: null, valueType: null, valueFormat: null }
